/**
 * @generated SignedSource<<fe0795a0897f130d16089d70f1ecdee9>>
 * @relayHash 1d68976fee055a5fb4c47e8819747e23
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 1d68976fee055a5fb4c47e8819747e23

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Data",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Country",
        "kind": "LinkedField",
        "name": "countries",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "country",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EscAdminQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EscAdminQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "1d68976fee055a5fb4c47e8819747e23",
    "metadata": {},
    "name": "EscAdminQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "708929eddda0395e0c66b7a93b2983e9";

export default node;
